import { REQUEST, SUCCESS, ERROR, ROOT } from './types'
import { buildQuery } from '../../utils/buildQuery'

const state = {
  data: {},
  loading: false,
  error: false
}

const getters = {
  list: (state) => state.data.docs,
  total: (state) => state.data.totalDocs,
  page: (state) => state.data.page,
  perPage: (state) => state.data.limit,
  dash: (state) => state.data.data
}

const actions = {
  async SetData(context, { _id, pagination }) {
    try {
      context.commit(REQUEST)

      if (!_id)
        throw new Error(
          'O _id da oferta não foi fornecido para o rastreamento!'
        )

      const { page, perPage } = pagination

      const response = await context.dispatch(
        `api`,
        {
          entity: `tracking`,
          action: `get`,
          params: { _id },
          query: `?page=${page || 1}&per_page=${perPage || 5}`
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, response.data)

      return
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao buscar os dados do rastreamento da viagem, por favor tente novamente mais tarde.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },

  async setList(context, { filters, pagination }) {
    try {
      context.commit(REQUEST)

      const { page, perPage, sortField, sortDirection } = pagination

      let query = {
        page: page || 1,
        per_page: perPage || 15,
        sort_field: sortField || ``,
        sort_direction: sortDirection || ``,
        driver_id: filters.driver_id || null,
        initial_date_start: filters.initial_date_start || null,
        final_date_start: filters.final_date_start || null,
        initial_date_delivered: filters.initial_date_delivered || null,
        final_date_delivered: filters.final_date_delivered || null,
        status: filters.status || null,
        offer_id: filters.offer_id || null
      }

      const response = await context.dispatch(
        `api`,
        {
          entity: `tracking`,
          action: `newDashboard`,
          query: buildQuery(query)
        },
        ROOT
      )

      const { data, status } = response

      if (status !== 200) throw response

      return context.commit(SUCCESS, { key: `dash`, data })
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao buscar os motoristas, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  }
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, payload) {
    state.data = payload
    state.loading = false
    state.error = false
  },
  [ERROR](state) {
    state.data = {}
    state.loading = false
    state.error = true
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
}
